import ReactMarkdown from "react-markdown";

import type { SummaryOutput } from "@frontierx/shared/schemas/Summary";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardTitle } from "@/components/ui/card";

import { CopyButton } from "../CopyButton";

export interface SummarySectionProps {
  title: string;
  items?: string[];
  value?: string;
}

const SummarySection = ({
  title,
  items,
  value,
}: Readonly<SummarySectionProps>) => {
  return (
    <Card>
      <CardTitle className="text-md border-b border-gray-300 px-4 py-4">
        <div className="flex w-full flex-row">
          <div className="flex-1">{title}</div>
          <div className="flex-0">
            {value && <CopyButton textToCopy={value} />}
            {items && (
              <CopyButton textToCopy={items.map((i) => `* ${i}`).join("\n")} />
            )}
          </div>
        </div>
      </CardTitle>
      <CardContent className="p-4">
        {value && (
          <div className="prose">
            <ReactMarkdown>{value}</ReactMarkdown>
          </div>
        )}
        {items && items?.length === 0 && <p>None</p>}
        {items && items?.length > 0 && (
          <ul className="list-inside list-disc">
            {items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
};

const SummaryDisplay = ({ summary }: { summary: SummaryOutput }) => {
  return (
    <div className="flex flex-col space-y-2">
      <h2 className="text-lg font-semibold">
        Sales Pipeline Status: {summary.salesPipelineStatus}
      </h2>

      <SummarySection
        title="Shareable Summary"
        value={summary.shareableSummary}
      />
      <SummarySection
        title="Unanswered Questions"
        items={summary.unansweredQuestions.items}
      />
      <SummarySection title="Next Steps" items={summary.nextSteps.items} />
      <SummarySection
        title="Internal Summary"
        items={summary.internalSummary.items}
      />
    </div>
  );
};
export const CallSummary = ({
  handleRequestSummary,
  summary,
}: {
  handleRequestSummary: () => void;
  summary: SummaryOutput | null;
}) => {
  return (
    <div className="flex flex-col space-y-4">
      {summary && <SummaryDisplay summary={summary} />}
      <div>
        <Button
          onClick={() => {
            handleRequestSummary();
          }}
        >
          Request summary
        </Button>
      </div>
    </div>
  );
};
